import React, { useRef, useEffect } from "react";
import { resizeCanvas, resizeCanvasToDisplaySize } from './util'

/**
 * Visualizes real-time frequency analysis data using an AnalyserNode.
 * @param {Object} props
 * @param {AudioEnv} props.audioEnv - The AudioEnv instance managing audio processing.
 */
const Analyzer = ({ audioEnv, globalMode, mapToCanvas }) => {
    const canvasRef = useRef(null);
    const animationFrameId = useRef(null);

    useEffect(() => {
        if (!audioEnv || !canvasRef.current || globalMode !== 'user-setting') return;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        resizeCanvas(canvas);
        resizeCanvasToDisplaySize(canvas);

        const analyser = audioEnv.getAnalyserNode();
        const frequencyData = new Uint8Array(analyser.frequencyBinCount);

        const calculateAnalysisXs = () => {
            return Array.from(frequencyData).map((_, i) => {
                let freq = i * (audioEnv.getCtx().sampleRate / 2) / (frequencyData.length);
                let { x } = mapToCanvas(ctx, freq, 0);
                return x;
            });
        };

        const draw = () => {
            analyser.getByteFrequencyData(frequencyData);

            ctx.clearRect(0, 0, canvas.width, canvas.height);

                // Create gradient fill (from bottom to top)
            const gradient = ctx.createLinearGradient(0, canvas.height, 0, 0);
            gradient.addColorStop(1, "rgba(63, 197, 242, 0.11)"); // Light Blue
            gradient.addColorStop(0.3, "rgba(208, 203, 252, 0.21)"); // Light Blue
            gradient.addColorStop(0.1, "rgba(247, 167, 207, 0.31)"); // Pink

            ctx.fillStyle = gradient;
            ctx.strokeStyle = "rgba(255, 255, 255, 0.8)"; // White outline for clarity
            ctx.lineWidth = 0.5;
            
            ctx.beginPath();
            for (let i = 0; i < frequencyData.length; i++) {
                let x = analysisXs[i];
                let y = canvas.height - (frequencyData[i] / 300) * canvas.height;
                if (i === 0) ctx.moveTo(x, y);
                else ctx.lineTo(x, y);

                
            }
            
            ctx.lineTo(canvas.width, canvas.height); // Close bottom-right
            ctx.lineTo(0, canvas.height); // Close bottom-left
            ctx.closePath();
        
            ctx.fill(); // Fill with gradient
            ctx.stroke(); // Stroke for visibility

            animationFrameId.current = requestAnimationFrame(draw);
        };

        let analysisXs = calculateAnalysisXs();

        draw();

        return () => {
            if (animationFrameId.current) {
                console.log('Analyzer unmounted');
                cancelAnimationFrame(animationFrameId.current);
            }
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        };
    }, [audioEnv, globalMode, mapToCanvas]);

    return <canvas ref={canvasRef} className="analyzer-canvas eq-canvas" />;
};

export default Analyzer;
